import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import ComponentStatusesSettings from './ComponentStatusesSettings.tsx';

const queryClient = new QueryClient();

export default function ComponentStatuses() {
  return (
    <QueryClientProvider client={queryClient}>
      <ComponentStatusesSettings />
    </QueryClientProvider>
  );
}
